module.exports = __webpack_public_path__ + "static/media/logo.604ea86e.jpg";